import { formatUsdValue } from '@/utils/helpers';

export default {
  props: {
    cardMasked: {
      type: String,
      default: '',
    },
    amount: {
      type: [String, Number],
      default: 0,
    },
    feePercent: {
      type: Number,
      required: true,
    },
    feeAmount: {
      type: [String, Number],
      default: '0.00',
    },
    wasFeeDiscountApplied: {
      type: Boolean,
      default: false,
    },
    isFeeWaived: {
      type: Boolean,
      default: false,
    },
    feeFreeAmount: {
      type: Number,
      default: 0,
    },
    feeCap: {
      type: Number,
      default: null,
    },
    hasPromo: {
      type: Boolean,
      default: false,
    },
    promotionalCreditAmount: {
      type: [String, Number],
      default: null,
    },
    promoCode: {
      type: String,
      default: '',
    },
    promoBonus: {
      type: [String, Number],
      default: '0.00',
    },
    separateCreditCode: {
      type: String,
      default: '',
    },
    separateCreditAmount: {
      type: [String, Number],
      default: 0,
    },
    totalToWallet: {
      type: [String, Number],
      default: '0.00',
    },
    arrivesText: {
      type: String,
      default: 'Instant',
    },
  },
  computed: {
    hasPromotionalCredit() {
      return this.promotionalCreditAmount !== '0.00' && this.promotionalCreditAmount !== 0 && this.promotionalCreditAmount !== null;
    },
    hasSeparateCredit() {
      return Number(this.separateCreditAmount) > 0;
    },
    formattedAmount() {
      return formatUsdValue(this.amount);
    },
    hasFeeSplit() {
      return this.wasFeeDiscountApplied && Number(this.feeAmount) > 0;
    },
    freeTierAmount() {
      return Math.min(Number(this.amount), Number(this.feeFreeAmount));
    },
    formattedFreeTierAmount() {
      return formatUsdValue(this.freeTierAmount);
    },
    formattedFirstAmountFree() {
      if (this.hasFeeSplit) {
        return this.formattedFreeTierAmount;
      }
      return this.formattedAmount;
    },
    overLimitAmount() {
      return Math.max(0, Number(this.amount) - this.freeTierAmount);
    },
    formattedOverLimitAmount() {
      return formatUsdValue(this.overLimitAmount);
    },
    formattedGrossAmount() {
      return formatUsdValue(this.amount);
    },
    formattedPromotionalCredit() {
      return formatUsdValue(this.promotionalCreditAmount);
    },
    formattedSeparateCredit() {
      return formatUsdValue(this.separateCreditAmount);
    },
    formattedFeeAmount() {
      return formatUsdValue(this.feeAmount);
    },
    formattedTotalToWallet() {
      return formatUsdValue(this.totalToWallet);
    },
    overLimitFeeLabel() {
      if (this.feeCap !== null && this.feeCap !== undefined && Number(this.feeCap) > 0) {
        return `Processing Fee (${this.feePercent}%, up to $${formatUsdValue(this.feeCap)})`;
      }
      return `Processing Fee (${this.feePercent}%)`;
    },
    feeDiscountMessage() {
      if (this.hasFeeSplit) {
        return `Your first $${this.formattedFreeTierAmount} is fee-free thanks to our FREE FIRST DEPOSIT promotion. The remaining $${this.formattedOverLimitAmount} is charged the standard processing fee.`;
      }
      return `Your $${this.formattedAmount} deposit is fee-free thanks to our FREE FIRST DEPOSIT promotion.`;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/shared/deposit-info-overview/deposit-info-overview.js